'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceCost$() {
  this.aLj = null;
  this.aLk = false;
  this.aLd = null;
  this.aLe = false;
  this.aLf = null;
  this.aLg = false;
  this.aLh = null;
  this.aLi = false;
  this.aLl = null;
  this.aLm = false;
  $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceCost$ = this;
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeBigDecimal__$init$__V(this);
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceCost$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceCost$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceCost$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceCost$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceCost$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceCost$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceCost$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceCost$.prototype = $p;
$p.o3 = (function() {
  if ((!this.aLk)) {
    this.aLj = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeBigDecimal$$anon$3(this);
    this.aLk = true;
  }
  return this.aLj;
});
$p.iq = (function() {
  if ((!this.aLe)) {
    this.aLd = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aLe = true;
  }
  return this.aLd;
});
$p.J2 = (function(x$0) {
});
$p.brR = (function() {
  if ((!this.aLg)) {
    this.aLf = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lalleycats_Empty$$anon$1(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0((() => {
      var $x_1 = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceCost$();
      var this$1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_package$().ox();
      var e$proxy10 = $x_1.iu(this$1.pp(0, this$1.hX));
      if ((e$proxy10 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
        throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalStateException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalStateException(), (("Expected Right, got Left(" + e$proxy10.bj) + ")"));
      }
      if ((e$proxy10 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
        return e$proxy10.aI;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(e$proxy10);
    })), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lalleycats_Empty$());
    this.aLg = true;
  }
  return this.aLf;
});
$p.afd = (function() {
  if ((!this.aLi)) {
    this.aLh = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Insurance Cost";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aLi = true;
  }
  return this.aLh;
});
$p.bNU = (function() {
  if ((!this.aLm)) {
    this.aLl = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().Cc;
    this.aLm = true;
  }
  return this.aLl;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceCost$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceCost$, "app.data.data_point_types$package$InsuranceCost$", ({
  FU: 1,
  B: 1,
  C: 1,
  cz: 1,
  fX: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceCost$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceCost$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceCost$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceCost$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceCost$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceCost$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceCost$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceCost$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceCost$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceCost$ };
//# sourceMappingURL=app.data.data_point_types$package$-Insurance-Cost$.js.map
